module.exports = __webpack_public_path__ + "img/con3_mockup_m.ac0b7982.jpg";